/*
 * This file is part of glowingblue/password-strength.
 *
 * Copyright (c) 2021 Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import Component from 'flarum/common/Component';
export default class StrengthIndicator extends Component {
  view() {
    const {
      label,
      color
    } = this.attrs;
    return m("div", {
      className: `StrengthIndicator ${label ? 'active' : ''}`
    }, m("div", {
      className: "StrengthIndicator-container"
    }, m("div", {
      className: "StrengthIndicator-pills"
    }, ['weak', 'medium', 'strong'].map(key => m(StrengthPill, {
      color: color,
      active: this.isPillActive(key)
    }))), m("div", {
      className: "StrengthIndicator-label"
    }, m("span", null, label))));
  }
  isPillActive(key) {
    const {
      score
    } = this.attrs;
    switch (key) {
      case 'weak':
        if (Number.isInteger(score)) {
          return true;
        }
      case 'medium':
        if (score !== undefined && score >= 2) {
          return true;
        }
      case 'strong':
        if (score !== undefined && score >= 4) {
          return true;
        }
      default:
        return false;
    }
  }
}
class StrengthPill extends Component {
  view() {
    const {
      color,
      active
    } = this.attrs;
    const backgroundColor = active ? color : undefined;
    return m("div", {
      className: "StrengthPill",
      style: {
        backgroundColor
      }
    });
  }
}
flarum.reg.add('glowingblue-password-strength', 'forum/components/StrengthIndicator', StrengthIndicator);